RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PhotoListItem = views.ContentListItem.extend({
        template: '#contentPhotoListItemTemplate'
    });

});
